import { render, staticRenderFns } from "./BillableManageServiceAdd.vue?vue&type=template&id=125fd6bb&scoped=true"
import script from "./BillableManageServiceAdd.vue?vue&type=script&lang=js"
export * from "./BillableManageServiceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fd6bb",
  null
  
)

export default component.exports